import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  PRODUCT_SOURCE_REQUEST,
  PRODUCT_SOURCE_SUCCESS,
  PRODUCT_SOURCE_FAILED,
  PRODUCT_SOURCE_CREATE,
  PRODUCT_SOURCE_CREATE_SUCCESS,
  PRODUCT_SOURCE_CREATE_FAILED,
  PRODUCT_SOURCE_DELETE,
  PRODUCT_SOURCE_DELETE_SUCCESS,
  PRODUCT_SOURCE_DELETE_FAILED,
  PRODUCT_SOURCE_EDIT,
  PRODUCT_SOURCE_EDIT_SUCCESS,
  PRODUCT_SOURCE_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * ProductSource Actions
 */

function* fetchProductSource({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/ProductSource/GetProductSource`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: PRODUCT_SOURCE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: PRODUCT_SOURCE_FAILED, payload: error.response });
    }
  }
}

function* createProductSource(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/ProductSource/CreateProductSource`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_SOURCE_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_SOURCE_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editProductSource(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/ProductSource/UpdateProductSource`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_SOURCE_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_SOURCE_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteProductSource(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/ProductSource/RemoveProductSource?ProductSourceId=${encodeURIComponent(action.payload.ProductSourceId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: PRODUCT_SOURCE_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_SOURCE_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootProductSourceList() {
  yield all([
    takeLatest(PRODUCT_SOURCE_REQUEST, fetchProductSource),
    takeLatest(PRODUCT_SOURCE_CREATE, createProductSource),
    takeLatest(PRODUCT_SOURCE_DELETE, deleteProductSource),
    takeLatest(PRODUCT_SOURCE_EDIT, editProductSource),
  ]);
}